import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CiMenuKebab } from "react-icons/ci";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MdHistory, MdEditCalendar } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineBarcode } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function CustomMenu({
  row,
  rowIndex,
  handleFieldChange,
  setGRNDetailsModal,
  setStockRecNotesHistoryModal,
  setLabelModal,
  user,
}) {
  const { t } = useTranslation(["inventory", "common"]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="table_action__wrap">
      <div className="table_action__btn" onClick={handleClick}>
        <CiMenuKebab size={10} style={{ marginRight: "2px" }} />
        {t("receiving.more")}
      </div>
      <Menu
        id={`basic-menu-${row.id}`} // Unique ID for each row
        anchorEl={anchorEl}
        open={open}
        size="small"
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `basic-button-${row.id}`, // Unique ID for each row
          "box-shadow": "none",
        }}
      >
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setGRNDetailsModal(row);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdEditCalendar
              size={15}
              style={{
                headerColor: "var(--color-brand)",
                cursor: "pointer",
              }}
            />
          </ListItemIcon>
          <ListItemText>{t("common:actions.view")}</ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            navigate(
              user?.role === "warehouseUser"
                ? "/warehouse-stock-received-form"
                : "/stock-received-form",
              {
                state: {
                  previousData: row,
                  mode: "edit",
                },
              }
            );
          }}
        >
          <ListItemIcon>
            <FaRegEdit size={15} />
          </ListItemIcon>
          <ListItemText>
            {user?.role === "warehouseUser" ? t("receiving.receive") : t("common:actions.edit")}
          </ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setStockRecNotesHistoryModal(row);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdHistory size={15} />
          </ListItemIcon>
          <ListItemText>{t("receiving.notes")}</ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setLabelModal({ row, rowIndex, handleFieldChange });
            handleClose();
          }}
        >
          <ListItemIcon>
            <AiOutlineBarcode size={15} />
          </ListItemIcon>
          <ListItemText>{t("receiving.barcode")}</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
